import { Link } from 'react-router';
import { NAV_PATH } from '@/router/constants';
import { UiCommon } from '@/common/common';

const GrowupPage = () => {
	const detailImg = {
		promotion1: require('@/assets/images/sub/img_promotion1.png'),
		promotion2: require('@/assets/images/sub/img_promotion2.png')
	};
	return (
		<main id="sub" className="sub promotion">
			<div className="sub-visual">
				<div className="sub-items"></div>
			</div>
			<div className="sub-content">
				<div className="inner">
					<img src={detailImg.promotion1} alt="연간 이용권 결제" />
					<div className="price-box">
						<img src={detailImg.promotion2} alt="스텔라 연간 이용권" />
						<Link className="price-link" to={NAV_PATH.PRICE}></Link>
					</div>
					<div className="button-group align-center">
						<a className="btn primary" onClick={() => UiCommon.goStellaService()}>
							혜택 신청하기
						</a>
					</div>
				</div>
			</div>
		</main>
	);
};

export default GrowupPage;
